import { React, useState } from "react";
import "./PopUpAmount.css";
import { Card, Text, Button, TextField, BlockStack } from "@shopify/polaris";
import { XIcon } from "@shopify/polaris-icons";

function PopUpAmount({ title, activated, passInfo, save }) {
  const [value, setValue] = useState(0);
  if (!activated) {
    return <></>;
  }

  const close = () => {
    setValue(0);
    passInfo({ activated: false, key: undefined, value: undefined });
  };

  return (
    <>
      <div className="popup_amount_blurred_bg" onClick={close} />
      <div className="popup_amount_window">
        <Card>
          <div style={{ display: "flex", marginBottom: "0.5rem" }}>
            <Text variant="headingMd">Editar {title}</Text>
            <span style={{ width: "25px", marginLeft: "auto" }}>
              <Button icon={XIcon} variant="plain" onClick={close} />
            </span>
          </div>
          <BlockStack gap={"300"}>
            <TextField
              value={value}
              type="number"
              onChange={(value) => {
                setValue(value);
              }}
              prefix="$"
            />
            <Button
              fullWidth
              onClick={() => {
                save(value);
                setValue(undefined);
                passInfo({
                  activated: false,
                  key: undefined,
                  value: undefined,
                });
              }}
            >
              Guardar
            </Button>
          </BlockStack>
        </Card>
      </div>
    </>
  );
}

export default PopUpAmount;
